
export default {
  watch: {
    'user.id': {
      handler: function (val, oldVal) {
        if (val !== oldVal && oldVal !== undefined) {
          console.log(`SOCKET - leave App.Api.M0001User.M0001UserModel.'${oldVal}`)
          this.$echo.leave(`private-App.Api.M0001User.M0001UserModel.'${oldVal}`)
        }
        this.$echo.private('App.Api.M0001User.M0001UserModel.' + val)
          .subscribed(() => {
            console.log('subscribed to private Channel: ' + val)
          })
          .notification((payload) => {
            console.log('notification:' + JSON.stringify(payload))
            switch (payload.type) {
              case 'App\\Api\\M0901Chatroom\\M0901ChatroomNotification':
                // console.log('NewMessage:' + JSON.stringify(payload.output))
                switch (payload.output.type) {
                  case 'newMessage':
                  case 'deleteMessage':
                    this.storeApiDispatch('M0901Chatroom/incomingMsg', payload.output.data, { loading: false })
                    break
                  // case 'newRoom':
                  //   this.$store.commit('M0901Chatroom/NEW_ROOM', payload.output.data)
                  //   break
                  default:
                    console.log('Unknown M0901ChatroomNotification type:' + payload.output.type + ' :' + JSON.stringify(payload.output))
                    break
                }

                break
              case 'App\\Events\\NewNotification':
                break
              default:
                console.log('Unknown type:' + payload.type + ' :' + JSON.stringify(payload))
                break
            }
          })
          .error(error => {
            console.log('error:' + JSON.stringify(error))
          })
      },
      immediate: true,
      deep: true
    }
  }
}
